/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {User} from '../shared/model/user';
import {ValidationModel} from './validation.model';

export class GpsRpo extends ValidationModel {
    id: number;
    rpo: string;
    type: string;
    programFamily: string;
    controller: string;
    architect: User;
    dse: User;
    fieldRules = [
        {fieldName: 'rpo', required: true, maxLength: 50, uniqueFieldSetName: 'rpo', forErrorMessage: 'GPS RPO'},
        {fieldName: 'type', required: false, maxLength: 500},
        {fieldName: 'programFamily', required: false, maxLength: 50},
        {fieldName: 'controller', required: false, maxLength: 50},
        {fieldName: 'architect', required: true, maxLength: 9},
        {fieldName: 'dse', required: false, maxLength: 9},
    ];

    setData(result) {
        Object.keys(result).forEach(field => {
            this[field] = result[field];
        });
        if (this.architect?.gmin) {
            this.architect = new User(this.architect['givenName'],
                this.architect['sn'], this.architect.gmin, this.architect['uid'], this.architect.email);
        }
        if (this.dse?.gmin) {
            this.dse = new User(this.dse['givenName'],
                this.dse['sn'], this.dse.gmin, this.dse['uid'], this.dse.email);
        }
    }
}
